import { centralEuropeanNow } from '../../../../play-core/utils/date-helper';
const pageSection = 'tv';
export const escPath = () => `/${pageSection}/best-of-esc`;
export const escPageRoute = () => ({
  pageId: 'esc',
  pageType: 'live',
  pageSection,
  path: escPath(),
  remixRoute: 'EscPage.remix-route.tsx'
});
export const escSecondLevelNaviLink = baseUrl => ({
  title: 'Best of ESC',
  path: baseUrl + escPath(),
  isActive: route => route.path === escPath()
});
export const allowEscRoute = serverEnvironment => {
  // Add ESC link to the live navigation from 05.05.2025 up to 25.05.2025
  const escStartDate = new Date('2025-05-05');
  const escEndDate = new Date('2025-05-26');
  const isEscPeriod = centralEuropeanNow() >= escStartDate && centralEuropeanNow() <= escEndDate;
  // allways show ESC link in the live navigation for non-productive environment
  const isNonProd = serverEnvironment !== 'production';
  return isEscPeriod || isNonProd;
};